export default __webpack_public_path__ + "static/media/certificate.2713d991.jpg";